import styled from 'styled-components/macro';
import { PrimaryButton, SecondaryButton } from '../../shared/Button';
import { Modal, ModalActionButtons, ModalHeader } from '../../shared/Modal';
import { spacing02 } from '../../styling/spacing';

type Props = {
  handleDelete: () => void;
  isOpen: boolean;
  closeModal: () => void;
  document: DocumentProps;
};

type DocumentProps = {
  documentReference: string;
  documentName: string;
  customerName: string;
  handoverPackSectionSequence: string;
  documentVersion: number | null;
};

export const DeleteDocumentWarningModal = ({ handleDelete, isOpen, closeModal, document }: Props) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Deleting Document</ModalHeader>
      <p>Are you sure you want to delete this document?</p>
      <DetailsContainer>
        <div>
          <DetailsTitle>Reference</DetailsTitle>
          <DetailsText>{document.documentReference}</DetailsText>
        </div>
        <div>
          <DetailsTitle>Document Name</DetailsTitle>
          <DetailsText>{document.documentName}</DetailsText>
        </div>
        <div>
          <DetailsTitle>Customer Name</DetailsTitle>
          <DetailsText>{document.customerName}</DetailsText>
        </div>
        <div>
          <DetailsTitle>Handover Pack Sequence</DetailsTitle>
          <DetailsText>{document.handoverPackSectionSequence}</DetailsText>
        </div>
        {document.documentVersion && (
          <div>
            <DetailsTitle>Version</DetailsTitle>
            <DetailsText>{document.documentVersion}</DetailsText>
          </div>
        )}
      </DetailsContainer>
      <ModalActionButtons $align="right">
        <PrimaryButton onClick={handleDelete}>Delete</PrimaryButton>
        <SecondaryButton onClick={closeModal}>Cancel</SecondaryButton>
      </ModalActionButtons>
    </Modal>
  );
};

const DetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing02};
  text-align: center;
`;

const DetailsTitle = styled.p`
  font-weight: bold;
  margin-bottom: 0;
`;

const DetailsText = styled.p`
  margin-top: 0;
`;
